export default __webpack_public_path__ + "static/media/4699@3x.482f755e.png";